/**
 * The Wallet chip's total in USDC units, at the last trades: USDC, plus Gaju
 * and XGE at their pairs' last trade. Null while Gaju is held and its pair has
 * no trade yet, so the chip never shows a figure that leaves part out.
 */
export function walletWorth(
  balances: { GAJU: string | null; USDC: string | null; XGE: string | null },
  pairs: readonly { name: string; lastPrice: string | null; priceUnit: string }[],
): bigint | null {
  const px = (name: string): bigint | null => {
    const p = pairs.find((x) => x.name === name);
    return p?.lastPrice ? BigInt(p.lastPrice) : null;
  };
  const unit = (name: string): bigint =>
    BigInt(pairs.find((x) => x.name === name)?.priceUnit ?? '1');
  const usdc = BigInt(balances.USDC ?? '0');
  const gaju = BigInt(balances.GAJU ?? '0');
  const xge = BigInt(balances.XGE ?? '0');
  const gajuPx = px('GAJU/USDC');
  const xgePx = px('XGE/USDC');
  let total = usdc;
  if (gaju > 0n) {
    if (gajuPx === null) return null;
    total += (gaju * gajuPx) / unit('GAJU/USDC');
  }
  if (xge > 0n && xgePx !== null) total += (xge * xgePx) / unit('XGE/USDC');
  return total;
}
